import "./App.css";
import AppRoute from "./routes/AppRoute";

function App() {
  return (
    <div className="">
      <AppRoute />
    </div>
  );
}

export default App;
